import { httpClient } from "./httpClient";

const getAllJobPosting = () => {
  return httpClient.get("jobposting");
};

export default {
  getAllJobPosting,
};
